module.exports = __webpack_public_path__ + "img/drug_hand.bd4b642a.svg";